(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_feature-callout"] && !Shopify.designMode) return;
  try {
    class FeatureCalloutElement extends HTMLElement {
    connectedCallback() {
      this._pill = this.querySelector('.feature-callout__pill--clickable');
      this._popover = this.querySelector('.feature-callout__popover');
      this._closeBtn = this.querySelector('.feature-callout__popover-close');

      if (!this._pill || !this._popover) return;

      this._pill.addEventListener('click', () => this._toggle());
      this._closeBtn?.addEventListener('click', (e) => {
        e.stopPropagation();
        this._close();
      });

      this._outsideHandler = (e) => {
        if (!this.contains(e.target)) this._close();
      };
      document.addEventListener('click', this._outsideHandler);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._outsideHandler);
    }

    _toggle() {
      if (this.hasAttribute('open')) {
        this._close();
      } else {
        // Close any other open callouts on the page
        document.querySelectorAll('feature-callout-element[open]').forEach((el) => el._close());
        this._open();
      }
    }

    _open() {
      this.setAttribute('open', '');
      this._popover.removeAttribute('hidden');
      this._pill.setAttribute('aria-expanded', 'true');
    }

    _close() {
      this.removeAttribute('open');
      this._popover?.setAttribute('hidden', '');
      this._pill?.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('feature-callout-element')) {
    customElements.define('feature-callout-element', FeatureCalloutElement);
  }
  } catch(e) { console.error(e); }
})();

})();
